import { FilterMatchMode } from "primereact/api";

export class Credito {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo_identificacion: {
                value: null,
                export: false,
                table: false,
                header: 'TIPO DE IDENTIFICACIÓN DEL DEUDOR:',
                required: 'Tipo de identificación es requerido',
            },
            identificacion: {
                value: '',
                export: false,
                table: false,
                header: 'IDENTIFICACIÓN DEL DEUDOR:',
                required: 'Identificación es requerida',
                maxLength: 'Máximo 20 caracteres',
                minLength: 'Mínimo 5 caracteres',
                max: 20,
                min: 5,
            },
            nombre_razon: {
                value: '',
                export: false,
                table: true,
                header: 'NOMBRE O RAZÓN SOCIAL:',
                required: 'Nombre o razón social es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            tipo_garantia: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de Garantía:',
                required: 'Tipo de Garantía es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            otra_garantia: {
                value: '',
                export: false,
                table: false,
                header: 'Otra garantía:',
                required: 'Otra garantía es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },        
            valor: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'Valor USD:',
                required: 'Valor es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
